<!-- 用户明细页面 -->
<template>
<a-row :gutter="24" class="new-row">
  <a-col :sm="24" :md="collapsed? 0: 5" class="new-col">
    <a-card :bordered="false" class="new-tree-card">
      <!-- 按钮操作区域 -->
      <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
        <a-alert type="info" :showIcon="true">
          <div slot="message">
            {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
            <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
          </div>
        </a-alert>
        <div style="display: flex;margin-top: 10px;">
          <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
          <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
        </div>
        <!-- 树-->
        <a-col :md="24" :sm="24" class="new-tree-col">
          <template>
            <a-spin tip="Loading..." :spinning="areaLoading">
              <!--
              <span style="user-select: none">
                <a-tree
                  class="my-area-select-tree"
                  :selectedKeys="selectedKeys"
                  :treeData="areaTree"
                  :checkStrictly="checkStrictly"
                  :expandedKeys="iExpandedKeys"
                  :autoExpandParent="autoExpandParent"
                  selectable
                  @expand="onExpand"
                  @select="onSelect">
                  <template slot="title" slot-scope="{title}">
                    <span v-if="title.indexOf(searchAreaValue) > -1">
                      {{title.substr(0, title.indexOf(searchAreaValue))}}
                    <span style="color: #32CD32">{{searchAreaValue}}</span>
                      {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                    </span>
                    <span v-else>{{title}}</span>
                  </template>
                </a-tree>
              </span>
              -->
              <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
            </a-spin>
          </template>
        </a-col>
      </div>
    </a-card>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed" ></a-icon>
    <a-card :bordered="false" class="new-table-card">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表编号')">
                <j-input :placeholder="$t('请输入表编号模糊查询')" v-model="queryParam.meterId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('表类型')">
                <a-select v-model="queryParam.meterType" :placeholder="$t('请选择表类型')">
                  <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                    {{data.mtName}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户编号')">
                <j-input :placeholder="$t('请输入用户编号模糊查询')" v-model="queryParam.userId"></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('用户姓名')">
                <j-input :placeholder="$t('请输入用户姓名模糊查询')" v-model="queryParam.userName "></j-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('用户地址')">
              <j-input :placeholder="$t('请输入用户地址模糊查询')" v-model="queryParam.userAddr"></j-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('阀门状态')">
                  <a-select v-model="queryParam.meterValveStatus" :placeholder="$t('请选择阀门状态')">
                    <a-select-option v-for="data in Object.keys(Mn100FkStatusObj)" :key="data" :value="data">
                      {{ $t(Mn100FkStatusObj[data]) }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item :label="$t('价格名称')">
                  <a-select v-model="queryParam.waterTypeId" :placeholder="$t('请选择价格名称')">
                    <a-select-option v-for="data in userPriceCode" :key="data.id" :value="data.id">
                      {{data.wtName}}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item :label="$t('告警类型')">
                <a-select v-model="queryParam.accountAlarmType" :placeholder="$t('请选择告警类型')" @change="$forceUpdate()">
                  <a-select-option :value="1">
                    {{ $t('余额达到报警金额') }}
                  </a-select-option>
                  <a-select-option :value="2">
                    {{ $t('余额达到透支金额') }}
                  </a-select-option>
                  <a-select-option :value="3">
                    {{ $t('自定义余额范围') }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :xl="6" :lg="11" :md="12" :sm="24" v-if="queryParam.accountAlarmType===3">
                <a-form-item :label="$t('用户余额范围')">
                  <div style="display: flex;">
                    <a-input-number v-model="queryParam.minValue" :precision="2" />
                    -
                    <a-input-number v-model="queryParam.maxValue" :precision="2" />
                    {{ $t('元') }}
                  </div>
                </a-form-item>
              </a-col>
            </template>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <div class="table-operator">
        <a-button type="primary" icon="download" @click="handleExportXls($t('用户余额'))">{{ $t('导出') }}</a-button>
        <a-button @click="handleBatchAdd(1)" type="primary" icon="plus">{{ $t('批量添加命令(按区域)') }}</a-button>
        <a-button @click="handleBatchAdd(2)" type="primary" icon="plus">{{ $t('批量添加命令(按表号)') }}</a-button>
        <a-button @click="handleBatchAdd(3)" type="primary" icon="plus">{{ $t('批量添加命令(按Excel表号)') }}</a-button>
        <span style="margin-left: 16px; font-size: 14px;">
          {{ $t('总预存金额：') }}<span style="color: #52c41a; font-weight: bold;">{{ totalPrepayBalance }}</span> {{ $t('元') }}
          <a-divider type="vertical" />
          {{ $t('总欠费金额：') }}<span style="color: #f5222d; font-weight: bold;">{{ totalArrearsBalance }}</span> {{ $t('元') }}
        </span>
      </div>
      <div class="table-fixed">
        <a-table
          ref="table"
          size="middle"
          :scroll="{x:true}"
          bordered
          rowKey="userKeyId"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :components="drag(columns)"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,onSelect:onTableSelect,onSelectAll:onSelectAll}"
          @change="handleTableChange">
          <div slot="filterDropdown">
            <a-card>
              <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                <a-row>
                  <template v-for="item in defColumns">
                    <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                      <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                    </template>
                  </template>
                </a-row>
              </a-checkbox-group>
            </a-card>
          </div>
          <span slot="userAccount" slot-scope="text, record">
            <a-tag style="font-size: 14px" :color="record.userAccountNum==null?'':record.userAccountNum<=0?'red': record.wtAlarmMoney<record.userAccountNum?'green':'orange'">{{record.userAccountNum}}</a-tag>
          </span>
          <span slot="wtPriceSlot" slot-scope="text, record">
            <span v-if="record.wtName"> {{record.wtName}}({{record.wtTotalPrice?record.wtTotalPrice + $t('元'): '--'}})</span>
            <span v-else>--</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a @click="handleDetail(record)">{{ $t('详情') }}</a>
            <a-divider type="vertical" />
            <a @click="record.mtCode=='WN100'?showMeterCommandQueue(record):showMeterCommandOldQueue(record)">{{ $t('命令队列') }}</a>
            <a-divider type="vertical" />
            <a @click="handleCommand(record)">{{ $t('命令下发') }}</a>
          </span>
        </a-table>
      </div>
      <meter-user-account-modal ref="modalForm" @ok="modalFormOk"></meter-user-account-modal>
      
      <meter-debuggingCommands-modal ref="debuggingCommandsModal" @ok="debuggingCommandsFormOk"></meter-debuggingCommands-modal>
      <debug-newCommand-modal ref="debugNewCommandModal" @ok="debuggingCommandsFormOk"></debug-newCommand-modal>
      <meter-command-queue-old-modal ref="metrCommandQueueOldModal" @ok="metrCommandQueueOldFormOk"></meter-command-queue-old-modal>
      <meter-command-queue-modal ref="metrCommandQueueModal" @ok="metrCommandQueueFormOk"></meter-command-queue-modal>
      
      <meter-batchCommandOld-modal ref="debugBatchCommandOldModal" @ok="debuggingCommandsFormOk"></meter-batchCommandOld-modal>
      <meter-batchCommandNew-modal ref="debugBatchCommandNewModal" @ok="debuggingCommandsFormOk"></meter-batchCommandNew-modal>
      <meter-dykj-debuggingCommands-modal ref="dykjDebuggingCommandsModal" @ok="modalFormOk"></meter-dykj-debuggingCommands-modal>
      <meter-batchCommandDykj-modal ref="debugBatchCommandDykjModal" @ok="debuggingCommandsFormOk"></meter-batchCommandDykj-modal>
      <debug-uSCommand-modal ref="debugUSCommandModal" @ok="modalFormOk"></debug-uSCommand-modal>
      <meter-batchCommandUS-modal ref="debugBatchCommandUSModal" @ok="debuggingCommandsFormOk"></meter-batchCommandUS-modal>
      
      <MeterY10QNDebuggingCommandsModal ref="y10qnDebuggingCommandsModal" @ok="modalFormOk"></MeterY10QNDebuggingCommandsModal>
      <MeterY17NDebuggingCommandsModal ref="y17nDebuggingCommandsModal" @ok="modalFormOk"></MeterY17NDebuggingCommandsModal>
      <MeterBatchCommandY10QNModal ref="debugBatchCommandY10QNModal" @ok="debuggingCommandsFormOk"></MeterBatchCommandY10QNModal>
      <MeterBatchCommandY17NModal ref="debugBatchCommandY17NModal" @ok="debuggingCommandsFormOk"></MeterBatchCommandY17NModal>
      <MeterBatchCommandY18NModal ref="debugBatchCommandY18NModal" @ok="debuggingCommandsFormOk"></MeterBatchCommandY18NModal>
      <MeterY18NDebuggingCommandsModal ref="y18nDebuggingCommandsModal" @ok="modalFormOk"></MeterY18NDebuggingCommandsModal>

      <MeterCommonCommandsModal ref="meterCommonCommandsModal" @ok="modalFormOk"></MeterCommonCommandsModal>
      <MeterBatchCommandCommonModal ref="debugBatchCommandCommonModal" @ok="debuggingCommandsFormOk"></MeterBatchCommandCommonModal>
      <a-modal
        :title="$t('选择批量下发表类型')"
        :visible="visible"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <div style="height: 400px">
          <a-select style="width: 100%" v-model="batchMtCode" :placeholder="$t('请选择表类型')">
            <a-select-option v-for="data in meterTypeList" :key="data.mtCode" :value="data.mtCode">
              {{data.mtCode}}
            </a-select-option>
          </a-select>
        </div>
      </a-modal>
    </a-card>
  </a-col>
</a-row>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import MeterUserAccountModal from './modules/MeterUserAccountModal'
  import { listSize } from '@/utils/util'
  import { httpAction, getAction } from '@/api/manage'
  import {isUndefinedAndNull,isUndefined,isEmptyObject} from'@/utils/validate'
  import {Mn100FkStatusObj} from '@/utils/constants/protocolConstant'
  import Vue from 'vue'
  import JInput from '@/components/jeecg/JInput'
  import TableDragResize  from '@/mixins/TableDragResize'
  // 
  import MeterDebuggingCommandsModal from '@/views/InternetDeviceManagement/modules/MeterDebuggingCommandsModal'
  import debugNewCommandModal from '@/views/InternetDeviceManagement/modules/debugNewCommandModal'
  import MeterBatchCommandOldModal from '@/views/InternetDeviceManagement/modules/MeterBatchCommandOldModal'
  import MeterBatchCommandNewModal from '@/views/InternetDeviceManagement/modules/MeterBatchCommandNewModal'
  import MeterDykjDebuggingCommandsModal from '@/views/InternetDeviceManagement/modules/MeterDykjDebuggingCommandsModal'
  import MeterBatchCommandDykjModal from '@/views/InternetDeviceManagement/modules/MeterBatchCommandDykjModal'
  import debugUSCommandModal from '@/views/InternetDeviceManagement/modules/debugUSCommandModal'
  import MeterBatchCommandUSModal from '@/views/InternetDeviceManagement/modules/MeterBatchCommandUSModal'
  import MeterY10QNDebuggingCommandsModal from '@/views/InternetDeviceManagement/modules/MeterY10QNDebuggingCommandsModal'
  import MeterY17NDebuggingCommandsModal from '@/views/InternetDeviceManagement/modules/MeterY17NDebuggingCommandsModal'
  import MeterBatchCommandY10QNModal from '@/views/InternetDeviceManagement/modules/MeterBatchCommandY10QNModal'
  import MeterBatchCommandY17NModal from '@/views/InternetDeviceManagement/modules/MeterBatchCommandY17NModal'
  import MeterBatchCommandY18NModal from '@/views/InternetDeviceManagement/modules/MeterBatchCommandY18NModal'
  import MeterY18NDebuggingCommandsModal from '@/views/InternetDeviceManagement/modules/MeterY18NDebuggingCommandsModal'
  import MeterCommandQueueOldModal from '@/views/InternetDeviceManagement/modules/meterCommandQueueOldModal'
  import MeterCommandQueueModal from '@/views/InternetDeviceManagement/modules/meterCommandQueueModal'

  import MeterBatchCommandCommonModal from '../InternetDeviceManagement/modules/MeterBatchCommandCommonModal'
  import MeterCommonCommandsModal from '../InternetDeviceManagement/modules/MeterCommonCommandsModal'
  export default {
    name: 'MeterUserAccountList',
    mixins:[JeecgListMixin, mixinDevice, AreaChoosetMixin,TableDragResize],
    components: {
      MeterUserAccountModal,
      JInput,
      MeterCommandQueueOldModal,
      MeterCommandQueueModal,
      MeterDebuggingCommandsModal,
      debugNewCommandModal,
      MeterBatchCommandOldModal,
      MeterBatchCommandNewModal,
      MeterDykjDebuggingCommandsModal,
      MeterBatchCommandDykjModal,
      debugUSCommandModal,
      MeterBatchCommandUSModal,
      MeterY10QNDebuggingCommandsModal,
      MeterY17NDebuggingCommandsModal,
      MeterBatchCommandY10QNModal,
      MeterBatchCommandY17NModal,
      MeterBatchCommandY18NModal,
      MeterY18NDebuggingCommandsModal,
      MeterBatchCommandCommonModal,
      MeterCommonCommandsModal
    },
    props: {},
    watch: {
      //监听搜索条件变化，当有搜索条件变化时，重置分页信息
      queryParam: {
        handler (newName, oldName) {
          this.ipagination.current = 1
        }
      }
    },
    data () {
      return {
        description: 'meter_user_account管理页面',
        collapsed: false,
        //表头
        columns:[],
        //列设置
        settingColumns:[],
        Mn100FkStatusObj: { ...Mn100FkStatusObj, 10000: '未知'},
        url: {
          list: "/jeecg-charge/meter/meterUserAccount/alarmList",
          delete: "/jeecg-charge/meter/meterUserAccount/delete",
          deleteBatch: "/jeecg-charge/meter/meterUserAccount/deleteBatch",
          exportXlsUrl: "/jeecg-charge/meter/meterUserAccount/exportAlarmXls",  //导出接口
          balanceSummary: "/jeecg-charge/meter/meterUserAccount/queryAlarmBalanceSummary",  //预存与欠费汇总
          importExcelUrl: "jeecg-charge/meter/meterUserAccount/importExcel",
          userPriceCode: "/jeecg-charge/meter/meterPriceinfo/list",  
          userTypeList:"/jeecg-charge/meter/meterType/list",  //表类型请求地址
        },
        dictOptions:{},
        userPriceCode:[], // 价格编码
        userTypeList:[],  //表类型
        queryParam: {
          accountAlarmType:undefined
        },
        visible: false,
        batchMtCode: '',
        batchType: '',
        batchRecord: '',
        meterTypeList:[{mtCode: 'WN100',mtName: 'WN100'},{mtCode: 'MN100',mtName: 'MN100'},{mtCode: 'MN100-2D',mtName: 'MN100-2D'},{mtCode: 'W12-N',mtName: 'W12-N'},{mtCode: 'Y10-QN',mtName: 'Y10-QN'},{mtCode: 'Y17-N',mtName: 'Y17-N'},{mtCode: 'Y18-N',mtName: 'Y18-N'},{mtCode: 'Y18-17',mtName: 'Y18-17'},{mtCode: 'Y28',mtName: 'Y28'}],
        // 预存金额(正数累加)与欠费金额(负数累加)汇总
        totalPrepayBalance: 0,
        totalArrearsBalance: 0,
      }
    },
    activated() {
      // 只有组件被keep-alive包裹才会触发改方法，由于改页面未使用缓存故将获取跳转参数放置在created中
      console.log("执行activated");
      //获取首页跳转传递的参数
      this.getParams();
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.queryUserTypeList();
      this.initColumns();
      this.queryUserPriceCode()
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:(t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon', }
          },
          {
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'meterUserId',
            width: 150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width: 150,
            ellipsis: true,
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true,
          },{
            title: this.$t('表类型'),
            align:"center",
            dataIndex: 'mtName',
            width: 150,
            ellipsis: true,
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            width: 150,
            ellipsis: true,
            customRender:(t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },{
            title: this.$t('当前余额(元)'),
            align:"center",
            dataIndex: 'userAccountNum',
            width: 100,
            ellipsis: true,
            scopedSlots: { customRender: 'userAccount' }
          },
          {
            title: this.$t('阀门状态'),
            align:"center",
            dataIndex:'meterValveStatus',
            customRender:(t,r,index) => {
              let data = Mn100FkStatusObj;
              if(isUndefined(data[t])) {
                return this.$t('未知');
              }
              return this.$t(data[t])
            },
            width:100,
            ellipsis: true
          },
          {
            title: this.$t('累计用量(m³)'),
            align:"center",
            dataIndex: 'userCalNum',
            customRender:(t,r,index) => {
              if(r.userStartCalNum>r.userTotalUseNum) {
                return r.userTotalUseNum;
              }
              return t
            },
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('充值次数'),
            align:"center",
            dataIndex: 'userPayTimes',
            width: 100,
            ellipsis: true,
            customRender:(t,r,index) => {
              return t?t:0;
            }
          },{
            title: this.$t('当前价格信息'),
            align:"center",
            dataIndex:'wtPrice',
            width:150,
            ellipsis: true,
            scopedSlots: { customRender: 'wtPriceSlot' },
          },{
            title: this.$t('更新时间'),
            align:"center",
            dataIndex: 'updateTime',
            width: 150,
            ellipsis: true
          },{
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:220,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      // 重置-(liya,2025-10-14，提出优化)
      searchReset() {
        this.queryParam = {}
        this.resetAareaData()
        this.date = []
        this.loadData(1);
        this.selectionRows = [];
        this.selectedRowKeys = [];
      },
      // 全选/取消全选
      onSelectAll(selected, selectedRows, changeRows) {
        let that = this
        if(selected) {
          this.selectionRows = this.selectionRows.concat(changeRows);
        }else{
          for(let i = 0;i<changeRows.length;i++) {
            let delIndex = that.selectionRows.findIndex(val => {
              return val.userKeyId === changeRows[i].userKeyId
            })
            that.selectionRows.splice(delIndex, 1);
          }
        }
      },
      queryUserTypeList() {   //表类型请求
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
            this.userTypeList = res.result.records;

          }
        }) 
      },
      getParams () {
        let routerParams = JSON.parse(JSON.stringify(this.$route.params));
        if(!isEmptyObject(routerParams)) {
          this.queryParam = this.$options.data.call(this).queryParam;
          if(!isUndefined(routerParams.accountAlarmType)){
            this.queryParam.accountAlarmType = routerParams.accountAlarmType
            this.toggleSearchStatus = true
          }
          this.loadData(true);
        }
      },
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t('请设置url.list属性!'))
          return
        }
        if(this.queryParam.accountAlarmType === 1||this.queryParam.accountAlarmType === 2) {
          if(!isUndefined(this.queryParam.minValue)) {
            delete this.queryParam.minValue
          }
          if(!isUndefined(this.queryParam.maxValue)) {
            delete this.queryParam.maxValue
          }
        }else{
          // 增加用户余额范围查询
          if(!isUndefinedAndNull(this.queryParam.minValue)&&!isUndefinedAndNull(this.queryParam.maxValue)) {
            if(this.queryParam.minValue>this.queryParam.maxValue) {
              this.$message.error(this.$t('用户余额起始值不能大于终止值'));
              return;
            }
          }
        }
        
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
            // 查询当前筛选条件下的预存金额(正数累加)与欠费金额(负数累加)汇总
            this.loadBalanceSummary(params);
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      queryUserPriceCode() {
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        params.statusDisable = 0;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
            console.log(this.userPriceCode);
          }
        })
      },
      // 查询预存金额(正数累加)与欠费金额(负数累加)汇总
      loadBalanceSummary(params) {
        if(!this.url.balanceSummary){
          return
        }
        getAction(this.url.balanceSummary, params).then((res) => {
          if(res.success && res.result){
            this.totalPrepayBalance = res.result.totalPrepayBalance || 0
            this.totalArrearsBalance = res.result.totalArrearsBalance || 0
          }
        })
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
      handleCommand(record) {
        record.mtCodeName = record.mtCode;
        if(record.mtCode=='WN100') {
          this.debugNewCommand(record);
        }else if(record.mtCode=='W12-N') {
          // 超声波水表
          this.debugUSCommand(record);
        }else if(record.mtCode=='MN100-2D') {
          this.dykjDebuggingCommands(record);
        }else if(record.mtCode=='Y10-QN'){
          this.y10qnDebuggingCommands(record);
        }else if(record.mtCode=='Y17-N'){
          this.y17nDebuggingCommands(record);
        }else if(record.mtCode == 'Y18-N'){
          this.y18nDebuggingCommands(record);
        }else if(record.mtCode=='Y18-17'){
          this.y17nDebuggingCommands(record);
        }else if(record.mtCode=='MN100'){
          this.debuggingCommands(record);
        }else {
          // 通用对接的命令
          record.meterType = record.mtCode

          this.debuggingCommonCommands(record);
        }
      },
      debuggingCommonCommands(record) {
        this.$refs.meterCommonCommandsModal.edit(record)
        this.$refs.meterCommonCommandsModal.title = this.$t('命令下发')
      },
      debuggingCommands(record) {
        this.$refs.debuggingCommandsModal.edit(record)
        this.$refs.debuggingCommandsModal.title = this.$t('命令下发')
        // this.queryUserTypeList(record)
      },
      dykjDebuggingCommands(record) {
        this.$refs.dykjDebuggingCommandsModal.edit(record);
        this.$refs.dykjDebuggingCommandsModal.title = this.$t('命令下发');
      },
      y10qnDebuggingCommands(record) {
        // 旌旗水表
        this.$refs.y10qnDebuggingCommandsModal.edit(record);
        this.$refs.y10qnDebuggingCommandsModal.title = this.$t('命令下发');
      },
      y17nDebuggingCommands(record) {
        // 三川和贝林水表
        this.$refs.y17nDebuggingCommandsModal.edit(record);
        this.$refs.y17nDebuggingCommandsModal.title = this.$t('命令下发');
      },
      y18nDebuggingCommands(record){
        this.$refs.y18nDebuggingCommandsModal.edit(record);
        this.$refs.y18nDebuggingCommandsModal.title = this.$t('命令下发');
      },
      // 新协议远程命令下发
      debugNewCommand(record) {
        this.$refs.debugNewCommandModal.edit(record)
      },
      debugUSCommand(record) {
        this.$refs.debugUSCommandModal.edit(record)
      },
      debugOldBatchCommand(record) {
        this.$refs.debugBatchCommandOldModal.edit(record)
        this.$refs.debugBatchCommandOldModal.title = this.$t('批量命令命令下发')
        // this.queryUserTypeList(record)
      },
      debugDykjBatchCommand(record) {
        this.$refs.debugBatchCommandDykjModal.edit(record)
        this.$refs.debugBatchCommandDykjModal.title = this.$t('批量命令命令下发')
        // this.queryUserTypeList(record)
      },
      // 新协议远程命令下发
      debugNewBatchCommand(record) {
        this.$refs.debugBatchCommandNewModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandNewModal.edit(record)
      },
      debugUSBatchCommand(record) {
        this.$refs.debugBatchCommandUSModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandUSModal.edit(record)
      },
      debugY10QNBatchCommand(record){
        this.$refs.debugBatchCommandY10QNModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandY10QNModal.edit(record)
      },
      debugY17NBatchCommand(record){
        this.$refs.debugBatchCommandY17NModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandY17NModal.edit(record)
      },
      debugY18NBatchCommand(record){
        this.$refs.debugBatchCommandY18NModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandY18NModal.edit(record)
      },
      debugCommonBatchCommand(record){
        this.$refs.debugBatchCommandCommonModal.title=this.$t('批量命令下发')
        this.$refs.debugBatchCommandCommonModal.edit(record)
      },
      handleCancel() {
        this.visible = false;
      },
      // type为1表示按照区域批量下发命令为2表示按照表编号批量下发命令，0表示单个下发命令
      handleOk() {
        if(this.batchMtCode === ''||this.batchMtCode === null) {
          this.$message.error(this.$t('请先选择批量下发命令的表类型'))
          return
        }
        this.visible = false
        this.handleMeterTypeSubmit({...this.batchRecord,mtCodeName:this. batchMtCode},this.batchMtCode)
      },
      handleMeterTypeSubmit(record,mtCode) {
        console.log("lalala")
      
        if(mtCode === 'WN100') {
          // 新协议
          this.debugNewBatchCommand(record)
        }else if(mtCode === 'W12-N'){
          this.debugUSBatchCommand(record)
        }else if(mtCode === 'MN100') {
          // 老协议
          this.debugOldBatchCommand(record)
        }else if(mtCode === 'MN100-2D') {
          // 端云科技大口径水表
          this.debugDykjBatchCommand(record)
        }else if(mtCode === 'Y10-QN') {
          // 旌旗水表
          this.debugY10QNBatchCommand(record)
        }else if(mtCode === 'Y17-N') {
          // 三川和贝林水表
          this.debugY17NBatchCommand(record)
        }else if(mtCode === 'Y18-N'){
          this.debugY18NBatchCommand(record)
        }else if(mtCode === 'Y18-17') {
          this.debugY17NBatchCommand(record)
        }else{
          // 通用接口对接
          this.debugCommonBatchCommand(record)
        }
      },
      // 批量添加命令
      handleBatchAdd(type) {
        this.batchType = type
        let record = {batchType: this.batchType}
        if(type === 1||type == 3) {
          // 按区域或者按照excel表格
          this.batchRecord = record
          this.visible = true
        }else if(type === 2) {
          // 按表号
          console.log(this.selectionRows)
          if(this.selectionRows.length<1){
            this.$message.error(this.$t('请先选择需要批量发送命令的表号'))
            return
          }else{
            let meterIdList = []
            let mtCode = ''
            for(let i = 0;i<this.selectionRows.length;i++) {
              if(i === 0) {
                mtCode = this.selectionRows[0].mtCode
              }else{
                if(mtCode !== this.selectionRows[i].mtCode) {
                  this.$message.error(this.$t('选择批量下发的表类型不一致不能操作，请重新选择同一表类型的表具'))
                  return
                }
              }
              meterIdList.push(this.selectionRows[i].meterId)
            }
            record.meterIdList = meterIdList.join(',')
            this.batchRecord = record
            this.handleMeterTypeSubmit({...this.batchRecord,mtCodeName:mtCode},this.selectionRows[0].mtCode)
          }
        }
        
      },
      showMeterCommandQueue(record) {
        this.$refs.metrCommandQueueModal.edit(record)
      },
      showMeterCommandOldQueue(record) {
        console.log("打开就协议命令modal")
        this.$refs.metrCommandQueueOldModal.edit(record)
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>